import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  { path: 'support', lazy: async () => ({ Component: (await import('./SupportPage')).SupportPage }) },
];
